import { Card } from 'components/tailwind-ui/Card';
import React from 'react';

interface Props {
  icon: React.ReactNode;
  title: string;
  value: string;
}

export const StatCard: React.FC<Props> = (props) => {
  return (
    <Card className="shadow-lg border-0">
      <div className="flex p-8 space-x-8">
        <div className="flex items-center">
          <div className="bg-blue-200 p-7 rounded-full">{props.icon}</div>
        </div>
        <div className="flex flex-col justify-between space-y-4">
          <h4 className="text-text-accent-3 text-2xl font-bold">{props.title}</h4>
          <h3 className="text-blue-800 text-8xl font-bold">{props.value}</h3>
        </div>
      </div>
    </Card>
  );
};
